import { DeliveryType } from "@types_def/models/delivery.types";
import { getDeliveryTypeAttributes } from "@utils/functions/Delivery/DeliveryType/deliveryTypeAttributes";

export const deliveryTypesRoutes = {
  okm: getDeliveryTypeAttributes(DeliveryType.OKM),
  standard: getDeliveryTypeAttributes(DeliveryType.STANDARD),
  "two-way-delivery": getDeliveryTypeAttributes(DeliveryType.TWO_WAY_DELIVERY),
  "to-return": getDeliveryTypeAttributes(DeliveryType.TO_RETURN),
};
